{
  "defaultTitle": "Не вдалося зареєструватись",
  "defaultMessage": "Будь ласка, підтвердіть інформацію у диспетчера або зверніться до складу",
  "backToHomescreen": "Повернутись на головний екран",
  "hideErrorLog": "ПРИХОВАТИ ЖУРНАЛ ПОМИЛОК",
  "viewErrorLog": "ПЕРЕГЛЯНУТИ ЖУРНАЛ ПОМИЛОК",
  "errorLogMessageLabel": "Повідомлення:",
  "errorLogStatusLabel": "Код статусу:",
  "unknown": "Невідомо"
}
